module.exports = __webpack_public_path__ + "img/01.800d1a27.jpg";